module.exports = __webpack_public_path__ + "img/maintop.959d335.png";